import { render, staticRenderFns } from "./MasterItemEvents.vue?vue&type=template&id=28eb8b27&scoped=true"
import script from "./MasterItemEvents.vue?vue&type=script&lang=js"
export * from "./MasterItemEvents.vue?vue&type=script&lang=js"
import style0 from "./MasterItemEvents.vue?vue&type=style&index=0&id=28eb8b27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb8b27",
  null
  
)

export default component.exports